var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-center"},[_c('img',{staticClass:"img",attrs:{"src":require("../img/empty/空空如也.png"),"alt":"","srcset":""}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }